<template>
  <div class="modal-backdrop" v-if="showModal" v-scroll-lock="showModal">
    <div class="modal">
      <button class="modal__cross" @click="closeModal">
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
      <form v-if="!formSent" @submit.prevent="submit" class="form">
        <h1 class="modal__title">Join the Challenge Now</h1>
        <div>
          <FormInput
            v-model="form.firstName"
            required
            placeholder="First Name"
          />
        </div>
        <div>
          <FormInput 
          v-model="form.lastName" 
          required 
          placeholder="Last Name" />
        </div>
        <div>
          <FormInput
            v-model="form.email"
            required
            placeholder="Email"
            type="email"
          />
        </div>
        <div>
          <masked-input
            class="input"
            mask="(111) 111-1111"
            placeholder="Mobile number (optional - only for reminder)"
            @input="form.phone = arguments[1]"
          />
        </div>
        <div>
          <SubmitButton :value="buttonText" />
        </div>
      </form>
      <div class="modal__success" v-else>
        Thank you for joining 10 Days to Portfolio Risk Mastery Challenge. You should receive
        calendar invitations for all sessions. If you do not see them in your
        inbox, please email
        <a href="mailto:support@rixtrema.com">
          support@rixtrema.com
        </a>
        <p style="margin-top: 10px">Below are the links to all sessions.</p>
        <div class="modal__schedule">
          <p>
            May 10 at Noon/12 PM EST: Session 1: Foundations of Risk - Part 1. <br>
            <a href="https://us06web.zoom.us/j/82473608401" target="_blank"
              >https://us06web.zoom.us/j/82473608401</a
            >
          </p>
          <p>
            May 12 at Noon/12 PM EST: Session 2: Foundations of Risk - Part 2.<br>

            <a href="https://us06web.zoom.us/j/82160362236" target="_blank"
              >https://us06web.zoom.us/j/82160362236</a
            >
          </p>
          <p>
            May 17 at Noon/12 PM EST: Session 3: Equity Risk Management - Part 1: Basics.<br>
            <a
              href="https://us06web.zoom.us/j/89417260300"
              target="_blank"
              rel="noopener noreferrer"
            >https://us06web.zoom.us/j/89417260300</a>
          </p>
          <p>
            May 19 at Noon/12 PM EST: Session 4: Equity Risk Management - Part 2: Portfolios.<br>
            <a
              href="https://us06web.zoom.us/j/82541078535"
              target="_blank"
              rel="noopener noreferrer"
            >https://us06web.zoom.us/j/82541078535</a>          
          </p>
          <p>
            May 24 at Noon/12 PM EST: Session 5: Fixed Income Risk Management - Part 1: Risk Factors.<br> 
            <a href="https://us06web.zoom.us/j/88521266337">https://us06web.zoom.us/j/88521266337</a>
          </p>
          <p>
            May 26 at Noon/12 PM EST: Session 6: Fixed Income Risk Management - Part 2: Curves.<br>
            <a href="https://us06web.zoom.us/j/85150654058">https://us06web.zoom.us/j/85150654058</a>
          </p>
          <p>
            May 31 at Noon/12 PM EST: Session 7: Behavioral and Historical Aspects of Risk.<br>
            <a href="https://us06web.zoom.us/j/86306358894">https://us06web.zoom.us/j/86306358894</a>
          </p>
          <p>
            June 2 at Noon/12 PM EST: Session 8: Analyzing Portfolio Risks.<br>
            <a href="https://us06web.zoom.us/j/81781982828">https://us06web.zoom.us/j/81781982828</a>
          </p>
          <p>
            June 7 at Noon/12 PM EST: Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc.<br>
            <a href="https://us06web.zoom.us/j/88202872937">https://us06web.zoom.us/j/88202872937</a>
          </p>
          <p>
            June 9 at Noon/12 PM EST: Session 10: Winning Clients with Risk Management.<br>
            <a href="https://us06web.zoom.us/j/89345994785">https://us06web.zoom.us/j/89345994785</a>
          </p>     
          
        </div>
        <button @click="copy" class="submit-button modal__copy">
          {{ copyText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import FormInput from './FormInput'
import SubmitButton from './SubmitButton'
import MaskedInput from 'vue-masked-input'
export default {
  components: {
    FormInput,
    SubmitButton,
    MaskedInput
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
      },
      buttonText: 'Submit 📨',
      formSent: false,
      copyText: 'Copy to Clipboard'
    }
  },
  computed: {
    showModal() {
      return this.$store.state.modal
    }
  },
  methods: {
    submit() {
      this.buttonText = 'Sending... ⏳'
      this.isSending = true
      this.$store
        .dispatch('sendEmail', this.form)
        .then(res => {
          console.log(res)
          this.$store
            .dispatch('logUser', this.form)
            .then(console.log)
            .catch(console.log)
          Promise.all([
            this.$store.dispatch('sendInvite1', this.form),
            this.$store.dispatch('sendInvite2', this.form),
            this.$store.dispatch('sendInvite3', this.form),
            this.$store.dispatch('sendInvite4', this.form),
            this.$store.dispatch('sendInvite5', this.form),
            this.$store.dispatch('sendInvite6', this.form),
            this.$store.dispatch('sendInvite7', this.form),
            this.$store.dispatch('sendInvite8', this.form),
            this.$store.dispatch('sendInvite9', this.form),
            this.$store.dispatch('sendInvite10', this.form),
          ]).then(() => {
            console.log('All promises setteled✅')
            this.formSent = true
            this.form = {
              firstName: '',
              lastName: '',
              phone: '',
              email: ''
            }
          })
        })
        .catch(err => {
          console.log(err)
          this.buttonText = 'Something went wrong ❌'
        })
    },
    closeModal() {
      this.$store.commit('setModal', false)
    },
    copy() {
      this.$clipboard(`May 10 at Noon/12 PM EST: Session 1: Foundations of Risk - Part 1. https://us06web.zoom.us/j/82473608401

      May 12 at Noon/12 PM EST: Session 2: Foundations of Risk - Part 2. https://us06web.zoom.us/j/82160362236

      May 17 at Noon/12 PM EST: Session 3: Equity Risk Management - Part 1: Basics. https://us06web.zoom.us/j/89417260300

      May 19 at Noon/12 PM EST: Session 4: Equity Risk Management - Part 2: Portfolios. https://us06web.zoom.us/j/82541078535
      
      May 24 at Noon/12 PM EST: Session 5: Fixed Income Risk Management - Part 1: Risk Factors. https://us06web.zoom.us/j/88521266337

      May 26 at Noon/12 PM EST: Session 6: Fixed Income Risk Management - Part 2: Curves. 
      https://us06web.zoom.us/j/85150654058

      May 31 at Noon/12 PM EST: Session 7: Behavioral and Historical Aspects of Risk. https://us06web.zoom.us/j/86306358894

      June 2 at Noon/12 PM EST: Session 8: Analyzing Portfolio Risks. https://us06web.zoom.us/j/81781982828

      June 7 at Noon/12 PM EST: Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc. https://us06web.zoom.us/j/88202872937

      June 9 at Noon/12 PM EST: Session 10: Session 10: Winning Clients with Risk Management. https://us06web.zoom.us/j/89345994785    
      
      `)
      this.copyText = 'Copied!'
    }
  }
}
</script>

<style lang="scss">
.modal-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal {
  padding: 40px;
  display: flex;
  // align-items: center;
  justify-content: center;
  position: relative;
  max-width: 700px;
  width: 100%;
  max-height: 100%;
  background-color: #e6dede;
  border-radius: 10px;
  text-align: center;

  &__schedule {
    margin-top: 16px;
    font-weight: 300;
    text-align: left;
    font-size: 12px;
    overflow: scroll;

    & > p {
      margin-top: 10px;
    }
  }

  &__copy {
    margin-top: 20px;
    width: 40%;
  }

  &__title {
    font-size: 20px;
    margin-bottom: 10px;
    color: #222;
  }

  &__success {
    font-size: 15px;
  }

  &__cross {
    position: absolute;
    height: 20px;
    width: 20px;
    top: 20px;
    right: 20px;
    cursor: pointer;
    border: none;
    outline: none;
    background-color: transparent;
  }

  .form {
    width: 100%;
    & > div {
      margin-bottom: 20px;
    }
  }
}
</style>
